export default __webpack_public_path__ + "static/media/badscan.7f211a0d.wav";